/**
 * Javascript file for the page with details on the current company. 
 * @author Adrian Rebmann, Steffen Schuhmann, Andrea Villeda
 */

import { getCompanyByHash } from "../../../../api";
export default {
  name: "CompanyDetail",
  props: ["hash"],

  /**
   * The vue instance's data object.
   * @property {object} company - The company item. 
   * @property {boolean} loading - Information is currently being processed.
   */
  data() {
    return {
      company: null,
      loading: false
    };
  },

  /**
   * Called after the instance has been created.
   */
  created() {
    this.loading = true;
    getCompanyByHash(this.hash)
      .then(res => {
        //console.log(res);
        this.company = res;
        this.loading = false;
      })
      .catch(err => {
        //console.log(err);
        this.loading = false;
      });
  },

  /**
   * The vue instance's method declaration.
   */
  methods: {
    /**
     * Returns to the previously visited page.
     */
    goBack() {
      this.$router.go(-1);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/search/companysearch/detail/companydetail.js